// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"162b613e","977":"5cb9cd4c"}[chunkId] + ".chunk.js";
};